/**
 * @generated SignedSource<<41fd7bbc7dbaa4ee8f42a2bc28ed5cdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZnglyInfo_SettingsStudioImages_Query$variables = Record<PropertyKey, never>;
export type ZnglyInfo_SettingsStudioImages_Query$data = {
  readonly znglyInfo: {
    readonly znglyInfo: {
      readonly pvImages: ReadonlyArray<{
        readonly image: {
          readonly description: string | null | undefined;
          readonly mediaDetails: {
            readonly sizes: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly sourceUrl: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly mediaItemUrl: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ZnglyInfo_SettingsStudioImages_Query = {
  response: ZnglyInfo_SettingsStudioImages_Query$data;
  variables: ZnglyInfo_SettingsStudioImages_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "id",
    "value": "site-info"
  },
  {
    "kind": "Literal",
    "name": "idType",
    "value": "SLUG"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaItemUrl",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDetails",
  "kind": "LinkedField",
  "name": "mediaDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ZnglyInfo_SettingsStudioImages_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ZnglyInfo",
        "kind": "LinkedField",
        "name": "znglyInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyInfo_Znglyinfo",
            "kind": "LinkedField",
            "name": "znglyInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_pvImages",
                "kind": "LinkedField",
                "name": "pvImages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaItem",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "znglyInfo(id:\"site-info\",idType:\"SLUG\")"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ZnglyInfo_SettingsStudioImages_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ZnglyInfo",
        "kind": "LinkedField",
        "name": "znglyInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ZnglyInfo_Znglyinfo",
            "kind": "LinkedField",
            "name": "znglyInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyInfo_Znglyinfo_pvImages",
                "kind": "LinkedField",
                "name": "pvImages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaItem",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": "znglyInfo(id:\"site-info\",idType:\"SLUG\")"
      }
    ]
  },
  "params": {
    "cacheID": "b07bc244fad4537303e6eeef01a80e50",
    "id": null,
    "metadata": {},
    "name": "ZnglyInfo_SettingsStudioImages_Query",
    "operationKind": "query",
    "text": "query ZnglyInfo_SettingsStudioImages_Query {\n  znglyInfo(id: \"site-info\", idType: SLUG) {\n    znglyInfo {\n      pvImages {\n        image {\n          mediaItemUrl\n          mediaDetails {\n            sizes {\n              sourceUrl\n              name\n            }\n          }\n          description\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "30895d2e8d29febf2ac58a64a564ea13";

export default node;
